<script setup lang="ts">
import { Modal, TextInput, AppButton, NumberInput } from '@pohlcon/design-system';
import { watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps<{
  rowKey: string | null;
  heatFlow?: number,
}>();

const modelValue = defineModel<boolean>('modelValue', { required: true });
const draftHeatFlow = defineModel<number | null>('draftHeatFlow', { required: true, default: null });

const emits = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
  (e: 'submit'): void;
}>();

watch(
  () => modelValue.value,
  (open) => {
    if (open) {
      draftHeatFlow.value = props.heatFlow ?? null;
    }
  },
);

const handleSubmit = () => {
  if (draftHeatFlow.value === null || Number.isNaN(draftHeatFlow.value)) return;

  emits('submit');
  emits('update:modelValue', false);
};
</script>

<template>
  <Modal
    v-model="modelValue"
    title="Edit Heat Flow"
    size="wide"
    closeButton
    @update:modelValue="(newValue) => emits('update:modelValue', newValue)"
  >
    <div class="edit-heat-flow-modal">
      <TextInput
        :modelValue="rowKey ?? ''"
        label="Row Key"
        :disabled="true"
      />
      <NumberInput
        v-model.number="draftHeatFlow"
        type="number"
        label="Heat Flow"
        :fractionDigits="4"
        placeholder="0.000"
        required
      />
    </div>
    <template #actions>
      <AppButton
        :text="t('actions.submit')"
        @click="handleSubmit"
      />
      <AppButton
        :text="t('actions.cancel')"
        @click="emits('update:modelValue', false)"
        secondary
      />
    </template>
  </Modal>
</template>

<style lang="scss" scoped>
.edit-heat-flow-modal {
  padding: var(--gutter-xs);

  .actions {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
